// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2zWyO","inputWrap":"CustomTip_inputWrap__2bCuj"};